import {
  getPhoneNumberPatternByCountry,
  setInputValidation,
  setPhoneInputValidationsByCountry,
} from '../configs/phone-validation-config'

/**
 * Custom Phone Validation using inputmask.js
 * We clone the value from the inputmask into a hidden text field
 * Resource: https://www.npmjs.com/package/inputmask
 */

export default function ApplicationPhoneFieldValidation(country) {
  const { inputValidations } = getPhoneNumberPatternByCountry(country)

  setPhoneInputValidationsByCountry(country)

  Object.values(inputValidations).forEach(validationRules => {
    setInputValidation(validationRules)
  })
}
